import clsx from 'clsx';
import { Theme } from '@mui/material/styles';
import { Typography, Box } from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';

import { PORTAL_PATH } from '../../../../../routes/paths';
import WithLink from '../../../../../common/link/withLink';
import QriosLogo from '../../../../../../assets/svg/qriosLogoWhite.svg';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logo: {
      padding: theme.spacing(3, 2),
      display: 'flex',
      alignItems: 'center'
    },
    title: {
      color: theme.palette.primary.contrastText,
      fontSize: '18px',
      whiteSpace: 'nowrap',
      marginLeft: theme.spacing(1)
    },
    linkWrapper: {
      textDecoration: 'none'
    },
    center: {
      justifyContent: 'center'
    }
  })
);

interface Props {
  isShrinked: boolean;
  isSelected: boolean;
}

const Logo = ({ isShrinked, isSelected }: Props) => {
  const classes = useStyles();

  return (
    <WithLink href={PORTAL_PATH.DASHBOARD} className={classes.linkWrapper} isSelected={isSelected}>
      <Box className={clsx(classes.logo, isShrinked && classes.center)}>
        <img alt="Qrios logo" src={QriosLogo} width="32px" height="32px" />
        {isShrinked ? null : (
          <Typography variant="h2" className={classes.title}>
            Developer Portal
          </Typography>
        )}
      </Box>
    </WithLink>
  );
};

export default Logo;
